import * as types from '../actions';

export default function(state = [], action) {
  const response = action.response;
  let timeVar = '~~'+Date.now(); 
  switch(action.type) {
    case types.EMAIL_VERIFICATION_SUCCESS:
      return { ...state, response };
    case types.EMAIL_VERIFICATION_ERROR:
      return { ...state, response };

    case types.RESET_PASSWORD_VERIFICATION_SUCCESS: 
      let forgotPwdVerifyResponse = response; 
      return { ...state, 
        forgotPwdVerifyActivity: types.RESET_PASSWORD_VERIFICATION_SUCCESS+timeVar,
        forgotPwdVerifyResponse };
    case types.RESET_PASSWORD_VERIFICATION_ERROR:
      return { ...state, 
        forgotPwdVerifyActivity: types.RESET_PASSWORD_VERIFICATION_ERROR+timeVar,
        forgotPwdVerifyResponse };  
    default:
      return state;
  }
};